module.exports = __webpack_public_path__ + "media/images/svgs/icon-favourites-add-872db86f20682788066d4581c6d2e94c.svg";